<template>
    <div class="transfer-files-personal" v-if="!isLoading">
        <div
          v-if="isAuthorized('gastouder', 'qualifications', 'view')"
          class="accordion mb-2"
          id="accordionFilesPersonalQualifications"
        >
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseQualifications"
                        aria-expanded="false"
                        aria-controls="collapseQualifications"
                    >Kwalificaties</button>
                </h2>
                <div
                    id="collapseQualifications"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFilesPersonalQualifications"
                >
                    <div class="accordion-body px-0">
                        <div class="list-group list-group-flush">
                            <div class="list-group-item d-none d-md-block bg-body-tertiary border-0">
                                <div class="list-group list-group-flush">
                                    <div class="list-group-item d-flex align-items-center me-4 py-0 bg-body-tertiary">
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="col offset-6">Startdatum</div>
                                                <div class="col">Verloopt op</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list-group-item">
                                <div
                                    class="list-group list-group-flush"
                                    v-bind:key="key" v-for="(qualification, key) in qualifications"
                                >
                                    <div class="list-group-item fw-bold">
                                        {{ qualification.name }}
                                    </div>
                                    <div
                                        class="list-group-item d-flex justify-content-between align-items-center"
                                        v-bind:key="rKey" v-for="(record, rKey) in qualification.records"
                                    >
                                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                            <div class="container-fluid">
                                                <div class="row">
                                                    <div class="col-12 col-md-6 text-truncate">{{ record.name }}</div>
                                                    <div class="col-auto col-md mobile-font-muted mobile-font-small">{{ record.start_date }}</div>
                                                    <div class="col-auto p-0 mobile-font-muted mobile-font-small d-block d-md-none">t/m</div>
                                                    <div class="col-auto col-md mobile-font-muted mobile-font-small">{{ record.end_date }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <span @click="downloadFile('qualification', record.name, record.id, record.isGroup)">
                                                <icon name="download" :fontSize="'1.5rem'"></icon>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div>
        <div
          v-if="isAuthorized('gastouder', 'documents', 'view')"
          class="accordion mb-2"
          id="accordionFilesPersonalDocuments">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseDocuments"
                        aria-expanded="false"
                        aria-controls="collapseDocuments"
                    >Documenten</button>
                </h2>
                <div
                    id="collapseDocuments"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFilesPersonalDocuments"
                >
                    <div class="accordion-body">
                        <div class="list-group list-group-flush">
                            <div class="list-group-item d-none d-md-block bg-body-tertiary border-0">
                                <div class="list-group list-group-flush">
                                    <div class="list-group-item d-flex align-items-center me-4 py-0 bg-body-tertiary">
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="col offset-6">Datum gewijzigd</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="list-group-item d-flex justify-content-between align-items-center"
                                v-bind:key="key" v-for="(document, key) in documents"
                            >
                                <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col-12 col-md-6 text-truncate">{{ document.name }}</div>
                                            <div class="col-auto col-md mobile-font-muted mobile-font-small">{{ document.modified_at }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <span @click="downloadFile('document', document.name, document.hash)">
                                        <icon name="download" :fontSize="'1.5rem'"></icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
          v-if="isAuthorized('gastouder', 'payout-details', 'view')"
          class="accordion mb-2"
          id="accordionFilesPersonalPayouts">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsePayouts"
                        aria-expanded="false"
                        aria-controls="collapsePayouts"
                    >Betaalspecificatie</button>
                </h2>
                <div
                    id="collapsePayouts"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFilesPersonalPayouts"
                >
                    <div class="accordion-body">
                        <div class="list-group list-group-flush">
                            <div
                                v-for="(yearData, yearKey) in payouts"
                                :key="yearKey"
                            >
                                <div
                                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center cursor-pointer bg-body-tertiary"
                                    @click="toggleYear(yearData.year)"
                                >
                                    <div class="fw-bold">{{ yearData.year }}</div>
                                    <div class="d-flex align-items-center">
                                        <div class="me-3 fw-bold">
                                            € {{
                                                parseFloat(yearData.totalAmount).toLocaleString("nl-NL", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })
                                            }}
                                        </div>
                                        <icon
                                            :name="expandedYears.includes(yearData.year) ? 'chevron-up' : 'chevron-down'"
                                            :fontSize="'1.2rem'"
                                        ></icon>
                                    </div>
                                </div>
                                <div v-if="expandedYears.includes(yearData.year)">
                                    <div class="list-group-item d-none d-md-block bg-body-tertiary">
                                        <div class="container-fluid">
                                            <div class="row me-4">
                                                <div class="col-3">Batchnummer</div>
                                                <div class="col-4">Datum</div>
                                                <div class="col-4">Bedrag</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="list-group-item d-flex justify-content-between align-items-center"
                                        v-bind:key="key"
                                        v-for="(payout, key) in yearData.payouts"
                                    >
                                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                            <div class="container-fluid">
                                                <a
                                                    @click="this.handleOpenPayoutDetailsModal(payout.idEuroCollect)"
                                                    class="text-decoration-none text-reset cursor-pointer"
                                                >
                                                    <div class="row me-4">
                                                        <div class="col-3 mobile-font-bold">
                                                            <span class="d-md-none">Batchnummer</span>
                                                            {{ payout.idEuroCollect }}
                                                        </div>
                                                        <div class="col-4">
                                                            <span class="d-md-none">Datum</span>
                                                            {{ this.$moment(payout.executeDate).format("DD-MM-YYYY") }}
                                                        </div>
                                                        <div class="col-4">
                                                            <span class="d-md-none">Bedrag</span>
                                                            € {{
                                                                parseFloat(payout.amount).toLocaleString("nl-NL", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                            }}
                                                        </div>
                                                        <div class="col-1 text-end">
                                                            <icon
                                                                name="look-into"
                                                                :fontSize="'1.5rem'"
                                                            ></icon>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
          v-if="isAuthorized('gastouder', 'agreements', 'view')"
          class="accordion mb-2"
          id="accordionFilesPersonalAgreements">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseAgreements"
                    aria-expanded="false"
                    aria-controls="collapseAgreements"
                >
                    Overeenkomsten
                </button>
            </h2>
        </div>
        <div
            id="collapseAgreements"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFilesPersonalAgreements"
        >
            <div class="accordion-body">
                <div class="list-group list-group-flush">
                    <div class="list-group-item d-none d-md-block me-4 bg-body-tertiary border-0">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-2">Verzorger</div>
                                <div class="col-2">Kind</div>
                                <div class="col-2">Datum overeenkomst</div>
                                <div class="col-2">Begin- einddatum opvang</div>
                                <div class="col-2">Status</div>
                                <div class="col-2">Datum verwerkt</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        v-bind:key="key"
                        v-for="(agreement, key) in agreements"
                    >
                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-6 col-md-2 text-truncate">{{ agreement.carerName }}</div>
                                    <div class="col-6 col-md-2">{{ agreement.childName }}</div>
                                    <div class="col-md-2 d-none d-md-block">{{ agreement.agreementDate }}</div>
                                    <div class="col-md-2 mobile-font-muted mobile-font-small">{{ agreement.scheduleStartEndDate }}</div>
                                    <div class="col-md-2 d-none d-md-block">{{ agreement.status }}</div>
                                    <div class="col-md-2 d-none d-md-block">{{ agreement.processDate }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="align-items-end">
                            <span @click="downloadAgreement(agreement)">
                                <icon name="download" :fontSize="'1.5rem'"></icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
          v-if="isAuthorized('gastouder', 'correspondence', 'view')"
          class="accordion mb-2"
          id="accordionFilesPersonalCorrespondence">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseCorrespondence"
                    aria-expanded="false"
                    aria-controls="collapseCorrespondence"
                >
                    Correspondentie
                </button>
            </h2>
        </div>
        <div
            id="collapseCorrespondence"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFilesPersonalCorrespondence"
        >
            <div class="accordion-body px-0">
                <div class="list-group list-group-flush">
                    <div class="list-group-item d-none d-md-block me-4 bg-body-tertiary border-0">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-5"></div>
                                <div class="col-5">Aangemaakt op</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        v-bind:key="key"
                        v-for="(correspondenceDocument, key) in correspondenceDocuments"
                    >
                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                            <div class="container-fluid">
                                <a @click="this.handleOpenCorrespondenceModal(correspondenceDocument.id)">
                                    <div class="row">
                                        <div class="col-5 text-truncate">{{ correspondenceDocument.name }}</div>
                                        <div class="col-5 text-truncate">{{ correspondenceDocument.createdAt }}</div>
                                        <div class="col-1">
                                            <div class="row justify-content-end">
                                                <icon name="look-into" :fontSize="'1.5rem'"></icon>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
          v-if="isAuthorized('gastouder', 'benefit-overview', 'view')"
          class="accordion mb-2"
          id="accordionFilesPersonalBenefitOverview">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseBenefitOverview"
                    aria-expanded="false"
                    aria-controls="collapseBenefitOverview"
                >
                    Vergoedingsoverzichten
                </button>
            </h2>
        </div>
        <div
            id="collapseBenefitOverview"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFilesPersonalBenefitOverview"
        >
            <div class="accordion-body px-0">
                <div class="list-group list-group-flush">
                    <div class="list-group-item d-none d-md-block me-4 bg-body-tertiary border-0">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-4">Nummer</div>
                                <div class="col-4">Periode</div>
                                <div class="col-4">Bedrag</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        v-bind:key="key"
                        v-for="(benefitOverview, key) in benefitOverviews"
                    >
                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-4 text-truncate">{{ benefitOverview.number }}</div>
                                    <div class="col-4 text-truncate">{{ benefitOverview.period }}</div>
                                    <div class="col-4 text-truncate">{{ benefitOverview.amount }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="align-items-end">
                            <span @click="downloadBenefitOverview(benefitOverview.id)">
                                <icon name="download" :fontSize="'1.5rem'"></icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
          v-if="isAuthorized('gastouder', 'annual-statement', 'view')"
          class="accordion mb-2"
          id="accordionFilesPersonalAnnualStatement">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseAnnualStatement"
                    aria-expanded="false"
                    aria-controls="collapseAnnualStatement"
                >
                    Jaaropgaven
                </button>
            </h2>
        </div>
        <div
            id="collapseAnnualStatement"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFilesPersonalAnnualStatement"
        >
            <div class="accordion-body px-0">
                <div class="list-group list-group-flush">
                    <div class="list-group-item d-none d-md-block me-4 bg-body-tertiary border-0">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-6">Jaar</div>
                                <div class="col-6">Datum</div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        v-bind:key="key"
                        v-for="(annualStatement, key) in annualStatements"
                    >
                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-6 text-truncate">{{ annualStatement.year }}</div>
                                    <div class="col-6 text-truncate">{{ annualStatement.date }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="align-items-end">
                            <span @click="downloadAnnualStatement(annualStatement.id)">
                                <icon name="download" :fontSize="'1.5rem'"></icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="alert alert-info" role="alert" v-if="isLoading">
        Laden...
    </div>

    <template v-if="showModal">
        <template v-if="this.modalType==='payoutDetails'">
            <PaymentSpecificationsModal :idEuroCollect="this.modalData.idEuroCollect" @close-modal="this.showModal=false"/>
        </template>
        <template v-if="this.modalType==='correspondence'">
            <PersonalCorrespondenceModal :idCorrespondenceDocument="this.modalData.idCorrespondenceDocument" @close-modal="this.handleCloseModal()"/>
        </template>
    </template>
</template>

<script>
import Icon from '@/components/Icon'
import PaymentSpecificationsModal from "./Modal/PaymentSpecifications.vue";
import PersonalCorrespondenceModal from "./Modal/Correspondence.vue";
import { downloadBase64File } from '@/helpers/DownloadFile.js'

export default {
    name: 'TransferFilesPersonal',
    components: {
        PersonalCorrespondenceModal,
        PaymentSpecificationsModal,
        Icon
    },
    data() {
        return {
            isLoading: false,
            qualifications: [],
            documents: [],
            payouts: [],
            showModal: false,
            modalType: '',
            modalData: null,
            agreements: [],
            correspondenceDocuments: [],
            benefitOverviews: [],
            annualStatements: [],
            expandedYears: []
        }
    },
    computed: {
        deviceToken() {
            return this.$store.getters.deviceToken
        },
        session() {
            return this.$store.getters.session
        },
    },
    created() {
        window.novict = {
            device: {
                device_token: this.deviceToken
            },
            session: {
                session_token: this.session.session_token
            }
        }
        this.isLoading = true;
        if (this.isAuthorized('gastouder', 'qualifications', 'view')) {
          this.getQualifications();
        }
        if (this.isAuthorized('gastouder', 'documents', 'view')) {
          this.getDocuments();
        }
        if (this.isAuthorized('gastouder', 'payout-details', 'view')) {
          this.getPayouts();
        }
        if (this.isAuthorized('gastouder', 'agreements', 'view')) {
          this.getAgreements();
        }
        if (this.isAuthorized('gastouder', 'correspondence', 'view')) {
          this.getCorrespondenceDocuments();
        }
        if (this.isAuthorized('gastouder', 'benefit-overview', 'view')) {
          this.getBenefitOverviews();
        }
        if (this.isAuthorized('gastouder', 'annual-statement', 'view')) {
          this.getAnnualStatements();
        }
        this.isLoading = false;
    },
    methods: {
        handleOpenPayoutDetailsModal(idEuroCollect) {
            this.modalType = 'payoutDetails';
            this.modalData = { idEuroCollect: idEuroCollect };
            this.showModal = true;
        },
        handleOpenCorrespondenceModal(idCorrespondenceDocument) {
            this.modalType = 'correspondence';
            this.modalData = { idCorrespondenceDocument: idCorrespondenceDocument };
            this.showModal = true;
        },
        handleCloseModal() {
            this.showModal = false;
            this.modalType = '';
            this.modalData = null;
        },
        getQualifications() {
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-qualifications/' + this.$store.getters.selectedGroupsQueryString).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.qualifications = response.qualifications
                }
            })
        },
        getDocuments() {
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-documents').then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.documents = response.documents
                }
            })
        },
        getPayouts() {
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-payouts').then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.payouts = response.payouts
                }
            })
        },
        getAgreements() {
            this.isLoading = true;
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-agreements/').then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.agreements = response.agreements
                }
                this.isLoading = false
            });
        },
        getCorrespondenceDocuments() {
            this.isLoading = true;
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-correspondence-documents/').then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.correspondenceDocuments = response.correspondenceDocuments
                }
                this.isLoading = false
            });
        },
        toggleYear(year) {
            if (this.expandedYears.includes(year)) {
                this.expandedYears = this.expandedYears.filter(y => y !== year);
            } else {
                this.expandedYears.push(year);
            }
        },
        downloadFile(resource, filename, id, isGroup = false) {
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.post('/download-personal-'+ resource, {
                file: id,
                isGroup: isGroup
            }).then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response && response.fileContent !== null) {
                    downloadBase64File(filename, response.fileContent)
                } else {
                    alert('Er is een fout opgetreden tijdens het downloaden. Probeer later opnieuw')
                }
            })
        },
        downloadAgreement(agreement) {
            this.isLoading = true
            this.$request.post('/download-personal-agreement', {
                idAgreement: agreement.id
            }).then((response) => {
                if (response.success) {
                    downloadBase64File(response.fileName, response.fileContent)
                } else {
                    alert('De overeenkomst kon niet worden gedownload')
                }
            }).finally(
                this.isLoading = false
            );
        },
        getBenefitOverviews() {
            this.isLoading = true;
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-benefit-overviews').then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.benefitOverviews = response.benefitOverviews
                }
                this.isLoading = false
            });
        },
        downloadBenefitOverview(idBenefitOverview) {
            this.isLoading = true
            this.$request.post('/download-personal-benefit-overview', {
                idBenefitOverview: idBenefitOverview
            }).then((response) => {
                if (response.success) {
                    downloadBase64File(response.benefitOverview.fileName, response.benefitOverview.fileContent)
                } else {
                    alert('Het vergoedingsoverzicht kon niet worden gedownload')
                }
            }).finally(
                this.isLoading = false
            );
        },
        getAnnualStatements() {
            this.isLoading = true;
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request.get('/personal-annual-statements').then((response) => {
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                    this.annualStatements = response.annualStatements
                }
                this.isLoading = false
            });
        },
        downloadAnnualStatement(idAnnualStatement) {
            this.isLoading = true
            this.$request.post('/download-personal-annual-statement', {
                idAnnualStatement: idAnnualStatement
            }).then((response) => {
                if (response.success) {
                    downloadBase64File(response.annualStatement.fileName, response.annualStatement.fileContent)
                } else {
                    alert('De jaaropgave kon niet worden gedownload')
                }
            }).finally(
                this.isLoading = false
            );
        },
    }
}
</script>

<style scoped>
.accordion-button:not(.collapsed) {
    color: #082F4D;
    background-color: #f2f9ff;
    box-shadow: none;
}
.accordion-body {
    padding: .5rem;
}

@media only screen and (max-width: 720px) {
    .mobile-font-muted {
        color: #6c757d;
    }
    .mobile-font-bold {
        font-weight: bold;
    }
    .mobile-font-small {
        font-size: .875rem;
    }
}
.cursor-pointer {
    cursor: pointer;
}
</style>